export default "__VITE_ASSET__9c01cbaf__"